<template>
  <el-dialog
    title="补齐交易对"
    :visible="visible"
    width="820px"
    :append-to-body="true"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form size="small" inline class="ele-form-search" @submit.native.prevent>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-refresh" class="ele-btn-icon"
          :loading="loading" @click="loadList">刷新</el-button>
        <el-button size="small" class="ele-btn-icon" :disabled="!selection.length"
          @click="clearSelection">清空选择</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="table"
      v-loading="loading"
      :data="list"
      border
      stripe
      size="small"
      height="420"
      @selection-change="onSelectionChange">
      <el-table-column type="selection" width="45" align="center" :selectable="canSelect" />
      <el-table-column prop="label" label="交易对" min-width="150" align="center" show-overflow-tooltip />
      <el-table-column prop="direction_label" label="方向" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.direction === 'reverse' ? 'warning' : ''" size="mini">
            {{ row.direction_label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="method_label" label="支付方式" width="100" align="center" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.exists ? 'info' : 'success'" size="mini">
            {{ row.exists ? '已存在' : '未生成' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rate_hint" label="参考汇率" width="120" align="center" />
    </el-table>

    <div slot="footer" class="ele-text-right">
      <el-button size="small" @click="updateVisible(false)">取消</el-button>
      <el-button size="small" type="primary" :loading="saving" :disabled="!selection.length" @click="submit">
        生成选中（{{ selection.length }}）
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PairFillDialog',
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      selection: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.selection = [];
        this.loadList();
      }
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    canSelect(row) {
      return !row.exists;
    },
    onSelectionChange(rows) {
      this.selection = rows || [];
    },
    clearSelection() {
      this.selection = [];
      if (this.$refs.table) {
        this.$refs.table.clearSelection();
      }
    },
    loadList() {
      this.loading = true;
      this.$http.get('/transmodel/getOkxPairOptions').then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.list = res.data.data || [];
          this.$nextTick(() => this.clearSelection());
        } else {
          this.$message.error(res.data.msg || '加载失败');
        }
      }).catch((e) => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    submit() {
      const pairs = this.selection
        .filter((item) => item.method)
        .map((item) => ({
          method: item.method,
          direction: item.direction === 'reverse' ? 'reverse' : 'forward'
        }));
      if (!pairs.length) {
        this.$message.error('请选择');
        return;
      }
      this.saving = true;
      this.$http.post('/transmodel/generateOkxPairs', { pairs }).then((res) => {
        this.saving = false;
        if (res.data.code === 0) {
          const data = res.data.data || {};
          this.$message.success(
            `${res.data.msg}：新增 ${data.created_count || 0} 个，跳过 ${data.skipped_count || 0} 个`
          );
          this.$emit('done');
          this.loadList();
        } else {
          this.$message.error(res.data.msg || '生成失败');
        }
      }).catch((e) => {
        this.saving = false;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
